import React from 'react';

function TermsComponent({ agreed, setAgreed }) {
  return (
    <div className="mt-6">
      <div className=" p-6 border border-gray-300 rounded-md bg-gray-50">
        <h3 className="text-lg font-semibold mb-2">IPSA Terms and Conditions</h3>
        <p className="mb-2">
          Welcome to the Institute for Patient Safety Africa (IPSA). By using our services,
          participating in our programs, or accessing our platform, you agree to the following terms:
        </p>
        <ul className="list-disc pl-5 space-y-2 text-sm">
          <li>
            <strong>Purpose:</strong> IPSA promotes patient safety through education, research, and collaboration across Africa.
          </li>
          <li>
            <strong>Use of Services:</strong> You agree to use IPSA resources ethically and in accordance with professional standards.
          </li>
          <li>
            <strong>Data Privacy:</strong> Personal data is handled securely and used only for IPSA’s mission.
          </li>
          <li>
            <strong>Intellectual Property:</strong> IPSA content may not be reproduced without permission.
          </li>
          <li>
            <strong>Limitation of Liability:</strong> IPSA is not liable for decisions based on its content or programs.
          </li>
          <li>
            <strong>Updates:</strong> IPSA may update these terms. Continued use implies acceptance.
          </li>
        </ul>
        <p className="mt-4 text-sm">
          Questions? Contact us at <a href="mailto:info@ipsa.africa" className="text-blue-600 underline">info@ipsa.africa</a>.
        </p>
      </div>

     
    </div>
  );
}

export default TermsComponent;
